import React, { useState, useEffect } from "react";

import { DefaultImageBaseurl, endPoints } from "../constant/Environment";
import {  getAllFilterData } from "../Utility/API";
import { Modal, Form, Button } from "react-bootstrap";


import Toaster from "../components/Toast";
import Loader from "../components/Loader";
import { ErrorToast, SuccesToast } from "../components/Toast/message";
import moment from "moment-timezone";
import { Col, Row, Container } from "react-bootstrap";
import successicon from "../assests/payments_icon/success.png";
const SuccesModal = (props) => {
  const [approveShow, setApproveShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { setSelectedData, selectedData } = props;
  const handleViewClose = () => {
    setApproveShow(false);
  };


  const approveTransaction = async () => {
    try {
      let url = `${endPoints.api.UPDATE_SOCIAL_POST}`;
      let data = {
        id: selectedData.id,
        id_user: selectedData.id_user,
        status: 1,
      };
      setIsLoading(true);
      let response = await getAllFilterData(url, data);
      setIsLoading(false);
      if (response.status == "success") {
        SuccesToast(response.message);
        setApproveShow(false);
      } else {
        ErrorToast(response.message);
      }
    } catch (Err) {
      console.log(Err);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <>
      <img
        src={successicon}
        style={{ height: "30px" }}
        onClick={() => {
          setSelectedData();
          setApproveShow(true);
        }}
      />

      <Modal
        show={approveShow}
        onHide={handleViewClose}
        size="lg"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header
          closeButton
          style={{ fontSize: "24px", fontWeight: "bold" }}
        >
          Request Approval
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row>
            <Toaster></Toaster>
              {isLoading && <Loader spinner={true} visible={isLoading} />}
              <Col xs={12}>
                <table className="table table-striped">
                  <tbody>
                    <tr>
                      <th>Customer ID:</th>
                      <td>{selectedData?.id_user}</td>
                      <th>Customer Name:</th>
                      <td>{selectedData?.name}</td>
                    </tr>
                    <tr>
                      <th>Offer Name:</th>
                      <td>{selectedData?.offerName}</td>
                      <th>Post Url:</th>
                      <td>{selectedData?.post_url}</td>
                    </tr>
                    <tr>
                      <th>Gold Coin :</th>
                      <td>{selectedData?.goldCoin}</td>
                    </tr>
                  </tbody>
                </table>
                <div style={{display:'flex',justifyContent:'center'}}>
                <img
                  src={`${DefaultImageBaseurl}${selectedData.post_image}`}
                  style={{ height: '200px' }}
                />
                </div>
              </Col>
            </Row>

            <Row>
              <Col xs={12} className="text-center">
                <p>
                  <b style={{ fontSize: "20px" }}>
                    Would you like to Approve this request?
                  </b>
                </p>
                <p style={{ fontSize: "12px" }}>
                  After approval, coins will be sent to the user account.
                </p>
                <Button
                  variant="primary"
                  size="lg"
                  block
                  style={{
                    borderRadius: "8px",
                    background: "#0A9B14",
                    border: "none",
                  }}
                  onClick={() => {
                    approveTransaction();
                  }}
                >
                  Approve Request
                </Button>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SuccesModal;
